import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const FolderChart = (props: IconProps) => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2581_6638)" {...props}>
                <path d="M20.6887 8.33333H34.9987C35.4407 8.33333 35.8647 8.50893 36.1772 8.82149C36.4898 9.13405 36.6654 9.55797 36.6654 10V33.3333C36.6654 33.7754 36.4898 34.1993 36.1772 34.5118C35.8647 34.8244 35.4407 35 34.9987 35H4.9987C4.55667 35 4.13275 34.8244 3.82019 34.5118C3.50763 34.1993 3.33203 33.7754 3.33203 33.3333V6.66667C3.33203 6.22464 3.50763 5.80072 3.82019 5.48816C4.13275 5.17559 4.55667 5 4.9987 5H17.3554L20.6887 8.33333ZM18.332 15V28.3333H21.6654V15H18.332ZM24.9987 20V28.3333H28.332V20H24.9987ZM11.6654 23.3333V28.3333H14.9987V23.3333H11.6654Z" fill={props.color || "#000"} />
            </g>
            <defs>
                <clipPath id="clip0_2581_6638">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default FolderChart